/**
 * This file is part of the "box.co.il" project.
 *
 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 */
;(function($) {
  
  /**
   * Translate message.
   * 
   * @param {String} message
   * @param {String} [locale]
   * 
   * @return {String}
   */
  $.translate = function(message, locale) {
    locale = locale || 'he';

    if(typeof undefined === typeof Storage) {
      return message;
    }
    
    var localization = Storage.getData('localization', false);

    if(false == localization || !(locale in localization) || !(message in localization[locale])) {
      return message;
    }

    return localization[locale][message];
  }
})(jQuery);